$('.hpe-input input, .hpe-input textarea').focus(function () {
  $(this)
    .parent()
    .addClass('hpe-input--active');
});

$('.hpe-input input, .hpe-input textarea').focusout(function () {
  if ($(this).val().length === 0) {
    $(this)
      .parent()
      .removeClass('hpe-input--active');
  }
});

$('.hpe-input__label').click(function () {
  $(this)
    .parent()
    .addClass('hpe-input--active');
  $(this)
    .next('input')
    .focus();
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/inputs.js